import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name: "authentication",
    initialState: {
        isAuthenticated: false,
        pageUrl: "/"
    },

    reducers: {
        setIsAuthenticated: (state, action) => {
            state.isAuthenticated = action.payload;
        },
        setPageUrl: (state, action) => {
            state.pageUrl = action.payload;
        }

    },
});

export const { setIsAuthenticated,setPageUrl } = authSlice.actions;

export default authSlice.reducer;